import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

import { environment } from '../../../../environments/environment';
import { LogService } from '../../../shared/logger/services/log.service';
import { LocalStorageService } from '../../../shared/services/local-storage.service';
import { BankFeedsModel } from '../../interfaces/bank-feeds.interface';
import { mockBankFeedsData } from '../../../../mock/bank-feeds.mock';

@Injectable({
  providedIn: 'root'
})
export class BankFeedsApiService {
  path = environment.apiUrl + 'BankFeeds';

  constructor(
    private http: HttpClient,
    private lSService: LocalStorageService,
    private logger: LogService
  ) {}

  getBankFeeds(orgId: string): Observable<BankFeedsModel[]> {
    this.logger.log('Service Call: Get Bank Feeds');
    return this.http.get<BankFeedsModel[]>(
      this.path,
      { params: { OrgId: orgId } }
    ).pipe(
      tap(() => this.logger.log('Service Call Complete: Get Bank Feeds')),
      map((res) => {
        if (!res.length) {
          return mockBankFeedsData;
        }
        return res;
      })
    );
  }

  importBankFeeds(file: FormData, orgId: string, accountId: string): Observable<any> {
    this.logger.log('Service Call: Import Bank Feeds');
    return this.http.post<any>(
      this.path + '/Import',
      file,
      { params: { OrgId: orgId, accountId } }
    ).pipe(tap(() => this.logger.log('Service Call Complete: Import Bank Feeds')));
  }

  reconcileBankFeed(body: any, orgId: string): Observable<void> {
    this.logger.log('Service Call: Reconcile Bank Feed');
    return this.http.post<void>(
      this.path + `/Reconcile?orgId=b3e1304f-6012-40c3-2ce5-08d9babf3a5a`,
      body
    ).pipe(tap(() => this.logger.log('Service Call Complete: Reconcile Bank Feed')));
  }
}
